import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles({
  heading: {
    fontSize: 24,
    lineHeight: '28px'
  },
  label: {
    fontSize: 18,
    fontWeight: 'bold'
  },
  paragraph: {
    fontSize: 16
  },
  customerParagraph: {
    fontSize: 14
  }
})

export default useStyles;